import { useEffect } from 'react'

import { getIsGretaAIChatChatRunning } from '../../../GretaAIChat.utils'
import { useGretaAIChatConversation } from '../../useGretaAIChatConversation'
import { useGretaAIChatFeedback } from '../../useGretaAIChatFeedback'

export function useGretaAIChatSessionConversation({
  activeChatId,
  chats,
  getIsChatGenerationSettledRecently,
  handleChatCreated,
  handleChatMissing,
  handleTurnSettled,
  markChatGenerating,
  openNewChat,
  revokeFinanceAccess,
  settleChatGeneration,
}) {
  const {
    discardUnsavedChat,
    forgetChat,
    isReplySettling,
    loadOlderMessages,
    messages,
    pendingAnswerFileName,
    reloadMessages,
    retryLastReply,
    sendMessage,
    status,
    stopGeneration,
    trackBackgroundGeneration,
    turnStartedAt,
  } = useGretaAIChatConversation({
    activeChatId,
    getIsGenerationSettledRecently: getIsChatGenerationSettledRecently,
    onChatCreated: handleChatCreated,
    onChatMissing: handleChatMissing,
    onGenerationSettled: settleChatGeneration,
    onSourceRevoked: revokeFinanceAccess,
    onTurnSettled: handleTurnSettled,
    onTurnStart: markChatGenerating,
  })

  function handleNewChat() {
    discardUnsavedChat()
    openNewChat()
  }

  useEffect(() => {
    chats.forEach(chat => {
      if (getIsGretaAIChatChatRunning(chat)) {
        trackBackgroundGeneration(chat.id)
      }
    })
  }, [chats, trackBackgroundGeneration])

  const { feedbackByMessageId, submitFeedback } = useGretaAIChatFeedback({
    activeChatId,
    messages,
  })

  return {
    conversation: {
      feedbackByMessageId,
      pendingAnswerFileName,
      status,
      turnStartedAt,
      onLoadOlderMessages: loadOlderMessages,
      onReloadMessages: reloadMessages,
    },
    conversationActions: {
      onNewChat: handleNewChat,
      onStop: stopGeneration,
      onSubmitFeedback: submitFeedback,
    },
    forgetChat,
    isReplySettling,
    messages,
    retryLastReply,
    sendMessage,
    status,
  }
}
